import { render, staticRenderFns } from "./UserBased.vue?vue&type=template&id=02b8219c&scoped=true"
import script from "./UserBased.vue?vue&type=script&lang=js"
export * from "./UserBased.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b8219c",
  null
  
)

export default component.exports